import styled from 'styled-components'
import theme from 'live/services/theme'

export const Content = styled.div`
    .back {
        position: absolute;
        right: 10px;
        top: 10px;
        font-size: 10px;
    }

    .radioImport {
        display: inline-block;
    }

    .pressuresComp {
        margin-top: 10px;
        font-weight: normal;
        font-size: 12px;
    }

    .porePressures {
        margin-top: 10px;
    }

    .right {
        text-align: right;
    }
    min-height: 360px;
`

export const BodyContent = styled.div`
    height: 300px;
`

export const ListItemContainer = styled.label`
    cursor: pointer;
    font-size: 13px;
    display: flex;
    align-items: ${({ elementName }) => (elementName ? 'flex-start' : 'center')};
    justify-content: flex-start;
    height: ${({ elementName }) => (elementName ? '45px' : '40px')};
    padding-top: ${({ elementName }) => (elementName ? '7px' : '0')};
    box-sizing: border-box;
    padding-left: 25px;
    background: #eeeeee;
    color: #606a80;
    &:hover {
        background: rgba(65, 191, 255, 0.15);
    }

    border-bottom: 1px solid #ddd;

`
export const TitleName = styled.div`
    color: #606a80;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    font-family: ${props => props.theme['font-regular']};
`

export const TreeElement = styled.div`
    font-size: 10px;
    color: #868695;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    font-family: ${props => props.theme['font-regular']};
`

export const ContainerInput = styled.div`
    display: flex;
    align-items: center;
    height: 40px;
    z-index: 5;
    > input {
        height: 40px;
        border: 1px solid #c8ccd4;
        border-left: none;
        border-right: none;
        outline: 0;
        color: #606a80;
        border-radius: none;
        outline: none;
    }
    > input:focus {
        border: 1px solid #c8ccd4;
        border-left: none;
        color: #606a80;
        border-right: none;
    }
    > i {
        border: 1px solid #c8ccd4;
        border-left: none;
        border-right: none;
        height: 40px;
        display: flex;
        align-items: center;
        font-size: 1.2em;
        padding: 0 15px 0 23px;
        background:white;
    }
    .fa-search {
        background: white;
    }
    .fa-times {
        cursor: pointer;
    }
`

export const ListItem = styled.div`
    display: flex;
    align-items: center;
    i {
        font-size: 16px;
        color: #37a3ef;
        margin-right: 7px;
    }
`
export const ContainerSubtitle = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 23px;
    height: 25px;
    border-bottom: 1px solid #c8ccd4;
    background: #f1f1f1;
`

export const ContainerBack = styled.div`
    display: flex;
    > i {
        color: #37a3ef;
        cursor: pointer;
        font-size: 11px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        margin-right: 5px;
    }
    > span {
        color: #37a3ef;
        cursor: pointer;
        font-size: 11px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        display: flex;
        font-family: ${props => props.theme['font-regular']};
    }
`

export const Subtitle = styled.div`
    i {
        margin-right: 3px;
        margin-left: 3px;
        text-decoration: none;
    }
`
export const NameFilter = styled.div`
    display: flex;
    /* margin-top: 10px; */
`

export const ContentActive = styled.span`
    font-size: 12px;
    cursor: pointer;
    font-weight: bold;
    color: ${({ active }) => (!active ? '#37a3ef' : '#868695')};
    &:hover {
        text-decoration: ${({ active }) => (!active ? 'underline' : 'none')};
    }
    > i {
        color: #868695;
    }
`

export const Loading = styled.div`
    &::before {
        background-color: transparent;
        min-height: 90px;
    }
`

export const ShowMsg = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
`
export const ErrorStyled = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 14px;
    font-family: ${props => props.theme['font-regular']};
    min-height: 320px;
    text-align: center;
    color: #868695;
`

export const IconFile = styled.i`
    font-size: 14px;
    margin-right: 5px;
`

export const ContainerCheckBox = styled.div`
    padding-left: 25px;
    label{
        text-transform:capitalize;
    }
`
export const OptionContent = styled.div`
    ${({ isSelectAll }) =>
        isSelectAll &&
        `
        margin-bottom: 15px;
        color: rgb(54, 65, 89);
        label {
            font-weight: bold !important;
            cursor: pointer;
            padding-right: 3px;
            font-size: 13px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            font-family: SourceSansPro-Regular, Arial, "Helvetica Neue", Helvetica, sans-serif;
        }
    `}
    .checkbox {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start

    }
    .checkbox label {
        cursor: pointer;
        padding-right: 3px;
        font-size: 13px;
        color: #606a80;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal
        font-family: ${props => props.theme['font-regular']};
    }
    .SelectAll {
        margin-bottom: 20px;

        > label {
            color: #364159;
            cursor: pointer;
            padding-right: 3px;
            font-size: 13px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            font-family: ${props => props.theme['font-regular']};
        }
    }
    .nameRadio {
        margin-left: 3px;
    }
`

export const StyledDiv = styled.div`
    padding: 15px 10px 10px 25px;
    font-size: 13px;
    font-size: 13px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    font-family: SourceSansPro-Regular, Arial, 'Helvetica Neue', Helvetica, sans-serif;
`
